import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ConfigProvider } from 'antd';
import axios from 'axios';

import { updatePageState } from '../data/redux/page_details/actions';
import { resetReduxState } from '../data/redux/admin_details/actions';

import { getLang, checkDevice, getLocalAdminDetails, showMessage, checkInternetConnection, log } from '../data/config/utils';
import { ROUTE_PATH, LOCAL_STORAGE, METHOD_TYPES } from '../data/config/constants';
import { CLOUD_URL } from '../data/config/urls';

import PageLoader from '../components/pageloader';
import NetworkAlert from '../components/NetworkAlert'

class App extends React.PureComponent {
  resizeTimer = null;

  componentDidMount() {
    const { actions } = this.props;
    const lang = getLang();
    if (lang)
      actions.updatePageState(lang, 'lang');
    actions.updatePageState(checkDevice.deviceStatus(), 'device_data');
    window.addEventListener("resize", () => {
      if (this.resizeTimer)
        clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        actions.updatePageState(checkDevice.deviceStatus(), 'device_data');
      }, 300);
    });
    checkInternetConnection();
    window.addEventListener('online', checkInternetConnection);
    window.addEventListener('offline', checkInternetConnection);
    const oriAdminDetails = getLocalAdminDetails();
    if (oriAdminDetails && oriAdminDetails.brandInfo)
      this.checkDashboardVersion({ brand: oriAdminDetails.brandInfo.name });
  }

  componentWillUnmount() {
    if (this.resizeTimer)
      clearTimeout(this.resizeTimer);
    window.removeEventListener('online', checkInternetConnection);
    window.removeEventListener('offline', checkInternetConnection);
  }

  checkDashboardVersion = data => {
    const { history, actions, dashboard_socket_details } = this.props;
    axios({
      method: METHOD_TYPES.GET,
      params: data,
      url: '/check_version',
      baseURL: CLOUD_URL,
    }).then(response => {
      log('response', response);
      if (response && response.data && response.data.version) {
        const version = JSON.parse(localStorage.getItem(LOCAL_STORAGE.VERSION));
        if (response.data.version !== version) {
          showMessage('info', 'your dashboard version has been changed so you need to login again.');
          localStorage.removeItem(LOCAL_STORAGE.ORI_ADMIN);
          localStorage.setItem(LOCAL_STORAGE.VERSION, JSON.stringify(response.data.version));
          if (dashboard_socket_details && dashboard_socket_details.connectivity.is_socket_connected)
            dashboard_socket_details.socket.close();
          history.push(ROUTE_PATH.LOGIN);
          actions.resetReduxState();
        }
      }
    }).catch(error => log('error', error));
  };

  render() {
    log('App rendered');
    const { is_internet_connected } = this.props
    return (
      <ConfigProvider>
        <div className="ori-full-width ori-relative">
          {
            !is_internet_connected &&
            <NetworkAlert />
          }
          <PageLoader />
          {this.props.children}
        </div>
      </ConfigProvider >
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboard_socket_details: state.dashboard_details.socket_details,
    is_internet_connected: state.page_details.is_internet_connected
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      resetReduxState,
      updatePageState,
    },
      dispatch)
  };
};

App.propTypes = {
  actions: PropTypes.object,
  dashboard_socket_details: PropTypes.object,
  is_internet_connected: PropTypes.bool,
  history: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(App));



// WEBPACK FOOTER //
// ./src/app/index.js